<template>
  <div style="color: #000">
    <div style="height: 100px"></div>

    <div class="service-bg animate__animated animate__backInLeft">
      <img src="../assets/img/product-bg.jpg" alt />
      <div class="common">
        <div class="service-title">
          <div class="service-title-top">亚太产品</div>
          <div class="service-title-bottom">Products</div>
        </div>
      </div>
    </div>

    <div class="service-menu-box animate__animated animate__backInLeft">
      <div
        :class="isActive == 0 ? 'active' : ''"
        class="service-menu-item"
        @click="isActive = 0"
      >
        信息系统集成软件产品
      </div>
      <div
        :class="isActive == 1 ? 'active' : ''"
        class="service-menu-item"
        @click="isActive = 1"
      >
      <a style="color:#000;" href="https://www.ezca.org/" target="_blank">
        电子认证服务产品</a>
      </div>
      <div
        :class="isActive == 2 ? 'active' : ''"
        class="service-menu-item"
        @click="isActive = 2"
      >
        代理产品
      </div>
    </div>
    <div class="product-cont animate__animated animate__backInLeft">
      <div class="common clearfix">
        <div class="product-cont-right">
          <div
            v-if="isActive == 0"
            class="animate__animated animate__backInLeft"
            key="product-cont1"
          >
            <div style="padding-bottom:120px">
              <div>
                <div style="height: 60px; width: 100%"></div>
                <div class="product-title">
                  <img src="../assets/img/line.png" alt="" />
                  <div class="produc-title-cont">教育行业</div>
                </div>
                <div class="product-mycont">
                  <img
                    src="../assets/img/study-pro.png"
                    alt=""
                    style="height: 220px; margin-top: 60px; width: 100%"
                  />
                  <ul class="product-cont-right-info-ul">
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太纯软件远程多媒体音视频会议系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太纯软件远程多媒体交互教学系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太教育城域网信息中心平台系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太在线考试系统
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <div style="height: 60px; width: 100%"></div>
                <div class="product-title">
                  <img src="../assets/img/line.png" alt="" />
                  <div class="produc-title-cont">医疗行业</div>
                </div>
                <div class="product-mycont">
                  <img
                    src="../assets/img/study-pro2.png"
                    alt=""
                    style="height: 220px; margin-top: 60px; width: 100%"
                  />
                  <ul class="product-cont-right-info-ul">
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太医院无线信息平台系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太医院管理系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太糖尿病健康管理系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      门诊医疗派驻保障工作数字化监管平台
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      派驻保障网络办公业务管理系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太健康档案管理系统
                    </li>
                  </ul>
                </div>
              </div>
              <div>
              <div style="height: 60px; width: 100%"></div>
                <div class="product-title">
                  <img src="../assets/img/line.png" alt="" />
                  <div class="produc-title-cont">大型企业</div>
                </div>
                <div class="product-mycont">
                  <img
                    src="../assets/img/study-pro3.png"
                    alt=""
                    style="height: 220px; margin-top: 60px; width: 100%"
                  />
                  <ul class="product-cont-right-info-ul">
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太资产管理系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太企业经营数据管理系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太企业资源计划系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太企业办公系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太进销存系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太客户CRM管理系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太通用库房管理系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太领航集成物流信息平台
                    </li>
                  </ul>
                </div>
              </div>

              <div style="height: 60px; width: 100%"></div>
                <div class="product-title">
                  <img src="../assets/img/line.png" alt="" />
                  <div class="produc-title-cont">政府行业</div>
                </div>
                <div class="product-mycont">
                  <img
                    src="../assets/img/study-pro4.png"
                    alt=""
                    style="height: 220px; margin-top: 60px; width: 100%"
                  />
                  <ul class="product-cont-right-info-ul">
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太云办公系统
                    </li>
                    <li>
                      <div class="set-circle"></div>
                      中讯亚太政务云数据平台
                    </li>
                   
                  </ul>
                </div>
              </div>
            </div>
           
          </div>
          <div
            v-if="isActive == 2"
            class="animate__animated animate__backInLeft"
            key="product-cont2"
            style="height:500px;"
          >
            <img class="myimg" style="width:1242px;
            margin:auto;height:226px;margin-top:80px;margin-bottom:50px" src="../assets/img/product-img.png" alt />
            <div class="product-cont-right-cont">
              <!-- 用友软件：代理用友全系列产品 -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
    };
  },
  methods: {
    handleToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    changeActive(value) {
      this.isActive = value;
    },
  },
  watch: {
    $route: function (to, from) {
      if (to.fullPath.indexOf("/product?activeNo=0") != -1) {
        console.log(0);
        this.changeActive(0);
        this.handleToTop();
      }
      if (to.fullPath.indexOf("/product?activeNo=1") != -1) {
        console.log(1);
        this.changeActive(1);
        this.handleToTop();
      }
      if (to.fullPath.indexOf("/product?activeNo=2") != -1) {
        console.log(2);
        this.changeActive(2);
        this.handleToTop();
      }
    },
  },
  mounted() {
    console.log(this.$route.query);
    this.isActive = this.$route.query.activeNo;
    this.handleToTop();
    // console.log(this.$route.query.activeNo);
  },
};
</script>

<style>
.service-bg {
  height: 450px;
  width: 100%;
  position: relative;
}
.service-bg img {
  width: 100%;
  height: 100%;
}

.service-title-top {
  font-size: 38px;
  line-height: 58px;
  font-weight: 800;
}
.service-title-bottom {
  color: #707070;
  font-size: 28px;
}
.product-mycont {
  width: 80%;
  margin: auto;
}

/* .product-cont-left {
  float: left;
} */
.product-cont-right {
  width: 100% !important;
}
.product-cont-left li {
  font-size: 20px;
  text-align: left;
  width: 260px;
  padding: 20px;
  padding-left: 0;
  border-bottom: 2px solid #c2c2c2;
}
.product-cont-left li:hover {
  cursor: pointer;
}
.product-cont-left li span {
  padding-left: 20px;
}
.product-cont-left li span.active {
  font-weight: 800;
  border-left: 7px solid #4774b6;
}
.product-cont-right img {
  width: 1000px;
  height: 320px;
}
.product-cont-right-cont {
  margin-top: 30px;
  font-weight: 800;
  font-size: 22px;
  color: #000;
}
.product-cont-right-info-box {
  margin-left: 50px;
  width: 480px;
}
.product-cont-right-info {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.product-cont-right-info-img {
  width: 600px;
  height: 430px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.product-cont-right-info-img > img {
  width: 420px;
  height: 340px;
}
.product-cont-right-info-title {
  font-size: 36px;
  text-align: left;
  font-weight: 800;
  line-height: 84px;
}
.product-cont-right-info-ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 40px;
}
.product-cont-right-info-ul li {
  width: 45%;
  font-size: 18px;
  line-height: 40px;
  text-align: left;
}
.product-cont-right-info-ul li:nth-child(2n-1) {
  margin-right: 50px;
}
.service-menu-box {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  font-size: 25px;
  line-height: 142px;
  padding: 0 80px;
}
.service-menu-item.active {
  color: #5694f5;
  font-weight: 600;
  border-bottom: 6px solid #5694f5;
}
.product-title {
  width: 405px;
  margin-top: 60px;
  margin: auto;
  font-size: 25px;
  font-weight: 800;
  position: relative;
}
.product-title img {
  width: 100%;
  height: 1px;
}
.produc-title-cont {
  position: absolute;
  left: 35%;
  top: 0px;
}
@media screen and (max-width: 1500px) {
  .service-title {
    height: 190px;
    width: 1000px;
  }
  .service-menu-box {
    width: 900px;
    margin-left: 100px;
  }
  .service-menu-item {
    width: 240px;
    font-size: 22px;
  }
  .service-menu {
    height: 100px;
    padding-top: 10px;
  }
  .product-cont-right-info-img {
    width: 400px;
    height: 330px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .product-cont-right-info-img > img {
    width: 320px;
    height: 240px;
  }
  .product-cont-right-info-ul li {
    font-size: 18px;
    line-height: 70px;
    width: 380px;
  }
  .product-cont-left li {
    font-size: 18px;
    text-align: left;
    width: 240px;
    padding: 20px;
    padding-left: 0;
    border-bottom: 2px solid #c2c2c2;
  }
  .product-cont {
    min-height: 600px;
    padding-top: 30px;
    background-color: #f7f8ff;
    display: flex;
  }
  .myimg {
    width: 600px !important;
  }
}
</style>